import React from 'react';
import { SketchPicker, GithubPicker, ColorResult } from 'react-color';

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Button,
  PopoverProps,
} from '@chakra-ui/react';

interface Props extends PopoverProps {
  color?: string;
  onColorChange: (color: string) => void;
  children?: React.ReactNode;
}
const ColorPickerPopover: React.FC<Props> = ({
  color,
  onColorChange,
  children,
  ...rest
}) => {
  const trigger = children ?? <Button>Selecionar</Button>;

  return (
    <Popover placement="left" {...rest}>
      <PopoverTrigger>{trigger}</PopoverTrigger>

      <PopoverContent
        borderWidth={2}
        color="black"
        bg="white"
        minWidth="350px"
        width="auto"
      >
        <PopoverHeader pt={4} fontWeight="bold" border="0">
          Selecionar cor
        </PopoverHeader>

        <PopoverArrow />
        <PopoverCloseButton />

        <PopoverBody
          maxHeight="400px"
          overflowY="auto"
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={4}
          sx={{
            '.github-picker': {
              '> span': {
                padding: '1px',
                '> div > span > div': {
                  borderRadius: '5px',
                },
              },
            },
          }}
        >
          <GithubPicker
            color={color}
            onChange={(c: ColorResult) => {
              onColorChange(c.hex);
            }}
            triangle="hide"
            width="325px"
            colors={[
              '#000000',
              '#C4C4C4',
              '#F6F6F6',
              '#FFFFFF',
              '#FF8A80',
              '#FF5252',
              '#FF1744',
              '#D50000',
              '#FFD180',
              '#FFAB40',
              '#FF9100',
              '#FF6900',
              '#FCB900',
              '#7BDCB5',
              '#00D084',
              '#00C853',
              '#00BFA5',
              '#80DEEA',
              '#8ED1FC',
              '#0693E3',
              '#00B8D9',
              '#ABB8C3',
              '#9900EF',
              '#FFC0CB',
            ]}
            styles={{
              default: {
                card: {
                  padding: '0px',
                  boxShadow: 'none',
                  border: 'none',
                },
              },
            }}
          />

          <SketchPicker
            color={color}
            onChange={(c: ColorResult) => {
              onColorChange(c.hex);
            }}
            disableAlpha
            presetColors={[]}
            styles={{
              default: {
                picker: {
                  width: '300px',
                  boxShadow: 'none',
                  border: 'none',
                  padding: '0px',
                },
              },
            }}
          />
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ColorPickerPopover;
